import moment from 'jalali-moment'
import { faPlain, longJalali } from 'utilities/helper/format'
import { jalaliDateOf } from '../grantFromDemand'

/**
 * The list endpoint sends Gregorian ISO timestamps. The old rows fed them to
 * `moment.from(value, 'YYYY-MM-DD')` — i.e. passed the FORMAT as the locale —
 * and printed whatever came out, in Latin digits. One place now turns them
 * into the «۱۸ شهریور ۱۴۰۵» every other redesigned screen uses.
 */
export const longDateOf = (iso?: string | null) =>
    iso ? longJalali(jalaliDateOf(iso)) : ''

export const timeOf = (iso?: string | null) => {
    if (!iso) return ''
    const value = moment(iso)
    return value.isValid()
        ? `${faPlain.format(value.hours())}:${String(value.minutes())
              .padStart(2, '0')
              .replace(/\d/g, (digit) => faPlain.format(Number(digit)))}`
        : ''
}

/** whole days since `iso`, never negative */
export const daysSince = (iso?: string | null) => {
    if (!iso) return 0
    const value = moment(iso)
    if (!value.isValid()) return 0
    return Math.max(
        0,
        moment().startOf('day').diff(value.clone().startOf('day'), 'days')
    )
}

/** «امروز» / «دیروز» / «۵ روز پیش» — how long a request has been waiting */
export const waitedLabel = (iso?: string | null) => {
    const days = daysSince(iso)
    if (days === 0) return 'امروز'
    if (days === 1) return 'دیروز'
    return `${faPlain.format(days)} روز پیش`
}

/** the first letter of a name, for the avatar circle */
export const initialOf = (name?: string | null) =>
    (name ?? '').trim().charAt(0) || '؟'
